import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../context";
import {
  finalUpload,
  backupImagesStatus,
  totalImagesUploadStatus,
  userLogs,
  patLogs,
  setFeedBackStatus,
  setRating,
  translateText,
  makeRequest,
  getAckoAnyGreyFlag,
  setAckoCompletionRedisTag,
  notifyParentApp,
  createInspectionCompletedEvent,
  createReloadEvent,
  getVideoRecordedFlag,
  getPendingVideosCount,
  getVideoUploadInfo
} from "../context/utils";
import Button from "./Button";
import successLoading from "../img/successLoading.gif";
import one_star from "../img/one_star.png";
import two_star from "../img/two_star.png";
import three_star from "../img/three_star.png";
import four_star from "../img/four_star.png";
import five_star from "../img/five_star.png";
import SafeImage from "./SafeImage";
let logsbugs = true;
var progressBar = require("progressbar.js");
let interval = null;
let ackoInterval = null;
let d = 0;
let resumeFlowUsedTagCheckFlag = true;
let resumeUsedTag = -1;
let uploadButton = false;
let upValue = 1;
let sendRetryEvent = true;
const emojis = [
  { value: 1, src: one_star, alt: "Very Sad" },
  { value: 2, src: two_star, alt: "Sad" },
  { value: 3, src: three_star, alt: "Neutral" },
  { value: 4, src: four_star, alt: "Happy" },
  { value: 5, src: five_star, alt: "Very Happy" },
];

const Success = () => {
  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const [screenHeight, setScreenHeight] = useState(land() ? false : true);
  const [barData, setBarData] = useState(0);
  const [commentTxt, setCommentTxt] = useState("");
  const [ratingValue, setRatingValue] = useState(0); // State to store the rating value
  const [innerHeight, setInnerHeight] = useState(`${window.innerHeight}px`); // State to store the rating value
  const [innerWeight, setInnerWeight] = useState(`${window.innerWeight}px`); // State to store the rating value
  let dRef = useRef(null);
  const pRef = useRef(null);
  const vRef = useRef(null);
  const ratingRef = useRef();

  const {
    setErrorMessage,
    setScreen,
    stepCovered,
    setStepCovered,
    config,
    inspectionId,
    uploaded,
    setUploaded,
    clientId,
    showAlert,
    setCurrentPage,
    token,
    caseId
  } = useContext(AppContext);

  window.onresize = () => {
    setScreenHeight(land() ? false : true);
    setInnerHeight(`${window.innerHeight}px`);
    setInnerWeight(`${window.innerWidth}px`);
  };

  if (logsbugs) {
    patLogs("Entered to image Uploading page", inspectionId);
    userLogs({ position: 8, last_page: "uploading page", inspectionId });
  }
  logsbugs = false;

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const imageStatus = async () => {
    // // console.log("upValue {{{{ ", upValue, uploaded)
    const data = totalImagesUploadStatus();
    if (pRef.current) {
      pRef.current.textContent = `${Object.keys(config["success-page"]).includes("ImageUploadingStatusTxt")
        ? config["success-page"]["ImageUploadingStatusTxt"]
        : getTranslateText("Images uploading")
        } ${data.uploadedImage + (upValue ? 0 : 1)} / ${data.totalImage + 1}`;
    }
    setBarData(
      (data.uploadedImage + (upValue ? 0 : 1)) / (data.totalImage + 1)
    );
    // Show video upload status in parallel, only when a video was recorded.
    if (vRef.current) {
      if (getVideoRecordedFlag()) {
        vRef.current.style.display = "block";
        const vinfo = getVideoUploadInfo();
        const sizeTxt = vinfo.sizeMB
          ? ` (${vinfo.sizeMB.toFixed(1)} MB)`
          : "";
        if (getPendingVideosCount() > 0) {
          const base = Object.keys(config["success-page"]).includes(
            "VideoUploadingStatusTxt"
          )
            ? config["success-page"]["VideoUploadingStatusTxt"]
            : getTranslateText("Video uploading");
          vRef.current.textContent = `${base} ${vinfo.percent}%${sizeTxt}`;
        } else {
          const base = Object.keys(config["success-page"]).includes(
            "VideoUploadedStatusTxt"
          )
            ? config["success-page"]["VideoUploadedStatusTxt"]
            : getTranslateText("Video uploaded");
          vRef.current.textContent = `${base}${sizeTxt}`;
        }
      } else {
        vRef.current.style.display = "none";
      }
    }
    if (["client_1381", "client_1381_prod", "arval_dev", "arval_prod"].includes(clientId)) {
      sendUploadProgressIFrame(
        ((data.uploadedImage + (upValue ? 0 : 1)) / (data.totalImage + 1)) * 100
      );
    }
    if (upValue === 0) {
      clearInterval(interval);
      setUploaded(true);
      patLogs("All images uploaded, At success page", inspectionId);
      //({ position: 8, last_page: "success page", inspectionId });
      setCurrentPage("Success Page");
    }
  };

  const sendUploadProgressIFrame = (percentage) => {
    // console.log("PERCENTAGE: ", Math.floor(percentage));
    window.top.postMessage(`PERCENTAGE: ${Math.floor(percentage)}`, "*");
  };

  const sendMessageIFrame = (message) => {
    if (message === "uploading" && clientId != "autogroup") {
      window.top.postMessage("uploading", "*");
    } else if (message === "retry upload" && clientId != "autogroup") {
      window.top.postMessage("retry upload", "*");
    } else {
      //// console.log("uploaded");
      window.top.postMessage("uploaded", "*");
      if (["client_1630", "client_1630_prod", "client_1630_dev", "client_1630_uat", "client_1630_stagging"].includes(clientId)) {
        const uploadCompleted = true;
        const policyNo = caseId;
        const events = [createReloadEvent(), createInspectionCompletedEvent({
          policyNo,
          uploadCompleted,
        })];
        notifyParentApp(events);
      }
      userLogs({ position: 8, uploaded_event_send: "yes", inspectionId });
    }
  };

  const startFinalUpload = async () => {
    // if (resumeFlowUsedTagCheckFlag && Object.keys(config).includes("imageFeedback") && (Object.keys(config).includes("resumeFlow") && config["resumeFlow"])) {
    //   resumeUsedTag = await makeRequest(`/fetchResumeCaseInImgFeedback/${inspectionId}`);
    //   resumeFlowUsedTagCheckFlag = false;
    // }
    if (
      resumeFlowUsedTagCheckFlag &&
      ["client_hiib", "client_hiib_uat", "car_type1"].includes(clientId) &&
      Object.keys(config).includes("imageFeedback")
    ) {
      resumeUsedTag = await makeRequest(
        `/fetchResumeCaseInImgFeedback/${inspectionId}`
      );
      resumeFlowUsedTagCheckFlag = false;
    }
    // if (!backupImagesStatus()) {
    let d;
    if (clientId === "client_507_testing") {
      d = true;
    } else {
      d = await finalUpload(
        Object.keys(config).includes("imageFeedback"),
        resumeUsedTag === -1 ? false : resumeUsedTag
      );
    }
    if (d === "usedToken") {
      patLogs("used token", inspectionId);
      clearInterval(interval);
      setErrorMessage(
        getTranslateText(
          "The link has already been used. Please contact your administrator for a new link"
        )
      );
      setScreen("error");
    } else if (d) {
      // console.log("INSPECTION_SUBMISSION_SUCCESS");
      upValue = 0;
      sendMessageIFrame();
    }
    // }
    // else if (uploadButton) {
    //   let b
    //   if (clientId === "client_507_testing") {
    //     b = true
    //   } else {
    //     b = await finalUpload(Object.keys(config).includes("imageFeedback"), resumeUsedTag === -1 ? false : resumeUsedTag);
    //   }
    //   // console.log("successs b ::: ", b)
    //   if (b === "usedToken") {
    //     patLogs("used token", inspectionId);
    //     clearInterval(interval);
    //     setErrorMessage(
    //       getTranslateText(
    //         "The link has already been used. Please contact your administrator for a new link"
    //       )
    //     );
    //     setScreen("error");
    //   } else if (b) {
    //     // console.log("INSPECTION_SUBMISSION_SUCCESS");
    //     upValue = 0;
    //     if (clientId !== "autogroup") sendMessageIFrame();
    //   }
    // }
  };

  useEffect(() => {
    if (dRef.current) drawProgress().animate(barData);
  }, [barData]);

  const drawProgress = () => {
    dRef.current.innerHTML = null;
    let bar = new progressBar.Circle("#progress-final", {
      strokeWidth: 6,
      easing: "easeInOut",
      duration: 2000,
      color: "#000000",
      trailColor: "#eee",
      trailWidth: 4,
      svgStyle: null,
      step: function (state, circle) {
        let value = Math.round(circle.value() * 100);
        circle.setText(`${value}%`);
      },
    });
    barData && bar.set(d);
    d = barData;
    return bar;
  };

  useEffect(() => {
    interval = setInterval(() => {
      imageStatus();
      startFinalUpload();
      if (backupImagesStatus() && sendRetryEvent) {
        sendRetryEvent = false;
        if (clientId !== "autogroup") sendMessageIFrame("retry upload");
      }
    }, 2000);
    if (
      ["client_1381", "client_1381_prod", "car_type1", "arval_dev", "arval_prod"].includes(
        clientId
      ) &&
      !getAckoAnyGreyFlag()
    ) {
      ackoInterval = setInterval(() => {
        const data = totalImagesUploadStatus();
        let percentage = Math.floor(
          ((data.uploadedImage + (upValue ? 0 : 1)) / (data.totalImage + 1)) *
          100
        );
        // // console.log("percentage anuj ::: ", percentage);
        if (percentage >= 85) {
          setAckoCompletionRedisTag();
          clearInterval(ackoInterval);
        }
      }, 500);
    }
    setFeedBackStatus("");
    if (clientId !== "autogroup") sendMessageIFrame("uploading");

    return () => {
      clearInterval(interval);
      clearInterval(ackoInterval);
    };
  }, []);

  useEffect(() => {
    if (uploaded) {
      if (
        Object.keys(config).includes("redirectUrl") &&
        config["redirectUrl"]
      ) {
        setTimeout(() => {
          window.location.href = config["redirectUrl"];
        }, 1000);
      }
      window.top.postMessage("uploaded", "*");
      if (["client_1630", "client_1630_prod", "client_1630_dev", "client_1630_uat", "client_1630_stagging"].includes(clientId)) {
        const uploadCompleted = true;
        const policyNo = caseId;
        const events = [createReloadEvent(), createInspectionCompletedEvent({
          policyNo,
          uploadCompleted,
        })];
        notifyParentApp(events);
      }
      userLogs({ position: 14, uploaded_event_send: "yes", inspectionId });
      if (Object.keys(config["success-page"]).includes("rating-popup")) {
        ratingRef.current.style.display = "flex";
      }
    }
  }, [uploaded]);

  const handleRatingSubmit = () => {
    // Handle the rating submission logic here
    setRating({
      feedback: ratingValue,
      comment: commentTxt,
      token: token,
    });
    ratingRef.current.style.display = "none";
  };

  const newUrl = () => {
    window.location.href = "https://webapp-gen.inspektlabs.com/login";
  };

  const handleChange = (e) => {
    setCommentTxt(e.target.value); // Update state with the value of the text field
  };

  return uploaded ? (
    <div
      id="final-screen"
      className="screen"
      style={{
        width: screenHeight ? "90%" : "",
        height: screenHeight ? "100%" : "",
        position: "relative",
      }}
    >
      {config["success-page"]["image"].length > 0 && (
        <SafeImage
          className="final-gif"
          src={config["success-page"]["image"]}
          style={{ width: screenHeight ? "40%" : "" }}
        />
      )}
      <p style={{ fontSize: screenHeight ? "large" : "" }}>
        {config["success-page"]["text1"]}
      </p>
      <p style={{ fontSize: screenHeight ? "large" : "" }}>
        {config["success-page"]["text2"]}
      </p>
      <p style={{ fontSize: screenHeight ? "large" : "" }}>
        {config["success-page"]["support-email-text"]}{" "}
        <span style={{ fontWeight: "bold" }}>
          {" "}
          {config["success-page"]["support-email"]}{" "}
        </span>
      </p>
      <br></br>
      {Object.keys(config["success-page"]).includes("inspection-id") &&
        <p
          style={{
            fontSize: screenHeight ? "large" : "10px",
            fontWeight: "lighter",
          }}
        >
          {config["success-page"]["inspection-id"]}: {["client_1630", "client_1630_prod", "client_1630_dev", "client_1630_uat", "client_1630_stagging"].includes(clientId) ? caseId : inspectionId}
        </p>
      }
      {clientId === "kshitij_testing" && (
        <div className="modal-btn-container">
          <button
            className="btn btn-blue"
            style={{ backgroundColor: "rgb(0, 108, 202" }}
            onClick={() => newUrl()}
          >
            Web Gen
          </button>
        </div>
      )}

      {/* Rating Popup */}
      <div
        ref={ratingRef}
        className="rating-popup"
        style={{
          width: screenHeight ? innerWeight : "100vw",
          height: screenHeight ? innerHeight : "100vh",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            height: screenHeight ? "60vh" : "70vh",
            width: screenHeight ? "180vw" : "50vw",
            zIndex: 5,
            backgroundColor: "white",
            borderRadius: "10px",
          }}
        >
          <h3
            style={{ margin: "0px", fontSize: screenHeight ? "xx-large" : "" }}
          >
            {config["success-page"]["rating-heading-txt"]
              ? config["success-page"]["rating-heading-txt"]
              : getTranslateText("Please rate your experience")}
          </h3>
          <div
            className="emoji-rating"
            style={{ width: screenHeight ? "70%" : "" }}
          >
            {emojis.map((emoji) => (
              <img
                key={emoji.value}
                src={emoji.src}
                alt={emoji.alt}
                onClick={() => setRatingValue(emoji.value)}
                style={{
                  cursor: "pointer",
                  opacity: ratingValue === emoji.value ? 1 : 0.5,
                  height: screenHeight ? "80px" : "",
                  width: screenHeight ? "80px" : "",
                }}
              />
            ))}
          </div>
          <input
            type="text"
            value={commentTxt}
            onChange={handleChange}
            placeholder={
              config["success-page"]["rating-comment-txt"]
                ? config["success-page"]["rating-comment-txt"]
                : getTranslateText("Comment Here..")
            }
            style={{
              padding: "6px",
              width: "80%",
              height: screenHeight ? "70px" : "40px",
              margin: "0px",
              fontSize: screenHeight ? "large" : "",
            }}
          />
          <button
            type="submit"
            disabled={ratingValue === 0}
            onClick={handleRatingSubmit}
            style={{
              width: screenHeight ? "300px" : "200px",
              lineHeight: "40px",
              border: "2px solid transparent",
              color: "var(--btn-text, #fff)",
              backgroundColor: config["colors"]["btn"],
              opacity: [ratingValue === 0 ? 0.4 : 1],
              fontSize: screenHeight ? "large" : "",
              padding: "5px",
            }}
          >
            {config["success-page"]["rating-btn-text"]
              ? config["success-page"]["rating-btn-text"]
              : getTranslateText("Submit")}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div id="final-screen" className="screen">
      <div ref={dRef} className="progress-final" id="progress-final"></div>
      <div
        style={{
          justifyContent: "space-around",
          alignItems: "center",
          width: "270px",
          display: "flex",
        }}
      >
        <p ref={pRef}></p>
        <img src={successLoading}></img>
      </div>
      <p ref={vRef} style={{ display: "none", margin: 0 }}></p>
      <h4>{config["success-page"]["uploading-text"]}</h4>
      <p>{config["success-page"]["tab-text"]}</p>
      <div className="InternetWarning">
        <p>{showAlert && showAlert}</p>
      </div>
      {/* {backupImagesStatus() && (
        <div className="modal-btn-container">
          <button
            className="btn btn-blue"
            style={{ backgroundColor: "rgb(0, 108, 202" }}
            onClick={() => (uploadButton = true)}
          >
            {
              ["client_1298", "client_1298_prod", "client_1298_dev"].includes(clientId) ?
                getTranslateText("Retry Uploading") : "Retry Uploading"
            }
          </button>
        </div>
      )} */}
    </div>
  );
};

export default Success;
